import { render, staticRenderFns } from "./list-with-sku.vue?vue&type=template&id=13b218fd&scoped=true"
import script from "./list-with-sku.vue?vue&type=script&lang=js"
export * from "./list-with-sku.vue?vue&type=script&lang=js"
import style0 from "./list-with-sku.vue?vue&type=style&index=0&id=13b218fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b218fd",
  null
  
)

export default component.exports